@if (isLoading()) {
  <lib-overlay-loader />
} @else {
  <header
    class="flex items-center justify-between py-lg border-b border-neutral-200">
    <h6 class="text-neutral-900 font-semibold text-lg px-lg">
      {{ 'profile_tab_title' | transloco }}
    </h6>

    <a
      class="flex items-center gap-sm px-xl py-sm font-medium text-primary-600 text-base"
      id="profile_tab_edit_button"
      [routerLink]="[
        `${EMPLOYEE_ROUTES.ACCOUNT_SETTINGS.EDIT_PROFILE}` | tenantPath,
      ]">
      <lib-edit-icon [iconClass]="'size-5 text-primary-600'" />

      {{ 'profile_tab_edit_button' | transloco }}
    </a>
  </header>

  <section class="py-lg">
    <lib-avatar
      [fullName]="profileDetails().name"
      [img]="profileDetails().image?.url ?? ''"
      [size]="''"
      [imgDimensions]="{ width: 64, height: 64 }"
      [placeholderTextClass]="'text-2xl'"
      borderRadius="rounded-full" />
  </section>

  <section
    class="grid [grid-template-columns:repeat(auto-fill,minmax(20rem,1fr))] gap-lg">
    <div>
      <label class="view-mode-label">
        {{ 'profile_tab_full_name_label' | transloco }}
      </label>

      <p class="view-mode-value break-word text-neutral-900">
        {{ profileDetails().name }}
      </p>
    </div>

    <div>
      <label class="view-mode-label">
        {{ 'profile_tab_phone_number_label' | transloco }}
      </label>

      <p class="view-mode-value break-word text-neutral-900">
        <span
          [dir]="profileDetails().phone?.international_number ? 'ltr' : 'auto'">
          {{
            profileDetails().phone?.international_number
              ? profileDetails().phone?.international_number
              : ('details_not_found_label' | transloco)
          }}
        </span>
      </p>
    </div>

    <div>
      <label class="view-mode-label">
        {{ 'profile_tab_email_address_label' | transloco }}
      </label>

      <p class="view-mode-value break-word text-neutral-900">
        {{
          profileDetails().email
            ? profileDetails().email
            : ('details_not_found_label' | transloco)
        }}
      </p>
    </div>

    <div>
      <label class="view-mode-label">
        {{ 'profile_tab_job_title_label' | transloco }}
      </label>

      <p class="view-mode-value break-word text-neutral-900">
        {{
          profileDetails().position?.job_title?.name ||
            ('details_not_found_label' | transloco)
        }}
      </p>
    </div>
  </section>
}
